import { chakra } from '@stockx/ui';

const StyledSkipToContent = chakra('a', {
  baseStyle: {
    bg: 'neutral.black',
    border: '3px solid white',
    color: '#fff !important',
    fontWeight: 'bold',
    padding: 2,
    position: 'absolute',
    transform: 'translateY(-200%)',
    transition: 'transform 0.3s',
    zIndex: 'skipLink',

    '&:focus': {
      left: 0,
      outline: '1px solid white',
      transform: 'translateY(0%)',
    },
  },
  label: 'StyledSkipToContent',
});

export default StyledSkipToContent;
